import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-laprueba',
  templateUrl: './laprueba.component.html',
  styleUrls: ['./laprueba.component.css']
})
export class LapruebaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
